<script>
  import { Router, Route, Link } from 'svelte-routing';
  import Home from './routes/Home.svelte';
  import About from './routes/About.svelte';
  import Donate from './routes/Donate.svelte';
  import Connect from './routes/Connect.svelte';
  import Outreach from './routes/Outreach.svelte';
  import Training from './routes/Training.svelte';
  import Live from './routes/Live.svelte';
  import Form from './routes/Form.svelte';
  import Curriculum from './routes/Curriculum.svelte';
</script>

<Router>
  <Route path="/" component={Home} />
  <Route path="/about" component={About} />
  <Route path="/donate" component={Donate} />
  <Route path="/outreach" component={Outreach} />
  <Route path="/connect" component={Connect} />
  <Route path="/live" component={Live} /> 
  <Route path="/form" component={Form} />  
  <Route path="/training" component={Training} />
  <Route path="/curriculum" component={Curriculum} />
</Router>